const permissionsAccess = (role, accessName) => {
  if (role?.permissions && role.permissions.length) {
    const currentPermission = role.permissions.find(
      (item) => item.resource === accessName
    );
    if (currentPermission) {
      return {
        read: currentPermission.read,
        showInMenu: currentPermission.showInMenu,
        write: currentPermission.write
      };
    } else return { read: false, write: false, showInMenu: false };
  } else return { read: false, write: false, showInMenu: false };
};
export default permissionsAccess;
